module.exports = __webpack_public_path__ + "img/main-top-min.0ba93889.png";